export default {
    "noData": "Không có bản ghi nào",
    "EmptyData": "Chưa có dữ liệu",
    "search": "Tìm kiếm...",
    FeaturesIsDeveloping: "Tính năng đang phát triển",
    "command": {
        "add": "Thêm",
        "edit": "Sửa",
        "update": "Cập nhật",
        "delete": "Xóa",
        "view": "Xem",
        "deleteField": "Xóa thông tin",
        "duplicate": "Nhân bản",
        "more": "Thêm nữa...",
        "save": "Lưu",
        "saveNew": "Lưu & Thêm",
        "close": "Đóng",
        "hide": "Ẩn",
        "help": "Giúp",
        "cancel": "Hủy",
        "accept": "Đồng ý",
        "saveAndNew": "Lưu và thêm mới",
        "confirm": "Xác nhận",
        "notConfirm": "Không xác nhận",
        "export": "Xuất khẩu",
        "finish": "Hoàn thành",
        "load": "Nạp",
        "print": "In",
        "filter": "Lọc",
        "refresh": "Nạp",
        "setting": "Thiết lập",
        "default": "Mặc định",
        "list": "Danh sách",
        "addDetail": "Thêm dòng",
        "addDetailShortKey": "Thêm dòng (F9)",
        "import": "Nhập khẩu",
        "logout": "Đăng xuất",
        "next": "Tiếp theo",
        "cancel": "Hủy",
        "back": "Quay lại",
        "move": "Di chuyển",
        "history": "Lịch sử",
        "recheck": "Kiểm tra lại"        
    },
    List: {
        SearchEmptyText: "Tìm kiếm"
    },
    module: {
        employee: "Nhân viên",
        deviceWideProfile: "Mục tiêu",
        device: "Thiết bị",
        scanEngine: "Engine",
        websiteDeepProfile: "Quét chuyên sâu",
        deviceDeepProfile: "Quét chuyên sâu",
        deviceWideScan: 'Lệnh quét diện rộng',
        deviceDeepScan: 'Lệnh quét chuyên sâu',
        users: "Người dùng",
        roles: "Vai trò",
        websiteWideProfile: 'Quét diện rộng',
        deviceWideProfile: 'Quét diện rộng',
        websiteWideScan: 'Lệnh quét diện rộng',
        websiteDeepScan: 'Lệnh quét chuyên sâu',
        proxy: 'Proxy',
        ScheduleJob: "Lịch quét",
        exploit: "Mã khai thác",
        attackProfile: "Kiểm thử",
        AttackTask: "Lệnh kiểm thử",
        poc: "Tấn công thử nghiệm",
        nzTemplate: "Template dò quét",
        leakAccount: 'Tài khoản lộ lọt',
        cvePoc: 'Mã kiểm thử theo cve',
        cvePocTask: 'Lệnh kiểm thử theo cve',
        user: 'Tài khoản',
        scheduleJob: 'Lịch chạy',
        watchlist: "Đối tượng theo dõi",
        reddit : "Cấu hình bộ từ khóa",
        rss: "Rss Source",
        channel : "Channel",
        setting: "Thiết lập",
        "monitor": "Monitor"
    }
};
